import React from 'react';
import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license-pro';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './ViewerApp/App';

Sentry.init({
  dsn: 'https://274de1e74e8e84245bb8c6dc1781ec98@o5762.ingest.us.sentry.io/4508801842216960',
  environment: process.env.NODE_ENV || 'production',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/mls-assist\.(staging|sandbox)?\.?theintelligenceplatform\.com$/,
  ],
});

const MUI_KEY =
  process.env.REACT_APP_MUI_LICENSE_KEY ||
  'ecae982de27fb1696804e43ba6652504Tz0xMzE4NjUsRT0xODE4MTE1MTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y';
LicenseInfo.setLicenseKey(MUI_KEY);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
